import { action, makeObservable, observable } from 'mobx';
import { isMobile } from '@pascal/pascal-core';

class LiveUpdateStore {
  allGamesLiveSpins = [];

  betCountView = isMobile() ? 10 : 20;

  constructor() {
    makeObservable(this, {
      allGamesLiveSpins: observable,
      setAllGamesLiveSpins: action.bound,
      updateAllGamesLiveSpins: action.bound,
    });
  }

  setAllGamesLiveSpins(data) {
    let allGamesLiveSpins = [...data];
    if (allGamesLiveSpins.length > this.betCountView) {
      allGamesLiveSpins = allGamesLiveSpins.splice(0, this.betCountView);
    }
    this.allGamesLiveSpins = allGamesLiveSpins;
  }

  updateLiveSpinUpdate(spin) {
    this.updateAllGamesLiveSpins(spin);
  }

  updateAllGamesLiveSpins(spin) {
    let allGamesLiveSpins = [spin, ...this.allGamesLiveSpins];
    if (allGamesLiveSpins.length > this.betCountView) {
      allGamesLiveSpins = allGamesLiveSpins.splice(0, this.betCountView);
    }
    this.allGamesLiveSpins = allGamesLiveSpins;
  }
}

export const liveUpdateStore = new LiveUpdateStore();
